/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import {
  Button,
  SplitButton,
  DropdownButton,
  Collapse,
} from 'react-bootstrap';
import ShowIf from 'loracoms/ShowIf';
import { bootstrapUtils } from 'react-bootstrap/lib/utils';
import IntlMsg from 'lorautils/intl/IntlMsg';
import TimeRangeButton from '../TimeRangeButton';
import NewGroupByButton from '../NewGroupByButton';
import NewFilterButton from '../NewFilterButton';
import NewSeriesButton from '../NewSeriesButton';
import GroupByTimeButton from '../GroupByTimeButton';
import DeviceSerieButton from '../DeviceSerieButton';
import GroupByFuncButton from '../GroupByFuncButton';
import DeviceFilter from '../DeviceFilter';
import {
  kGroupByTime,
  kGroupOneMin,
  kGroupFuncSum,
  kDeviceFilter,
  kSeriesDevice,
} from '../../constants';
import '../buttons.scss';
import styles from './styles.scss';

bootstrapUtils.addStyle(Button, 'aisz-new-cond');
bootstrapUtils.addStyle(SplitButton, 'aisz-new-cond');
bootstrapUtils.addStyle(DropdownButton, 'aisz-new-cond');
bootstrapUtils.addStyle(Button, 'aisz-time-range');
bootstrapUtils.addStyle(DropdownButton, 'aisz-time-range');
bootstrapUtils.addStyle(Button, 'aisz-time');
bootstrapUtils.addStyle(DropdownButton, 'aisz-time');
bootstrapUtils.addStyle(Button, 'aisz-device');
bootstrapUtils.addStyle(DropdownButton, 'aisz-func');
bootstrapUtils.addStyle(Button, 'aisz-func');

const propTypes = {
  data: React.PropTypes.object.isRequired,
  intl: React.PropTypes.any.isRequired,
  locale: React.PropTypes.string.isRequired,
  onChange: React.PropTypes.func.isRequired,
};


class Conditions extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      data: props.data,
    };
    this.intlMsg = new IntlMsg(props.intl, 'applicationdetail.parseview.dptrend');
    this.handleChangeTimeRange = this.handleChangeTimeRange.bind(this);
    this.handleAddGroupByDim = this.handleAddGroupByDim.bind(this);
    this.handleAddFilter = this.handleAddFilter.bind(this);
    this.handleRemoveGroupByDim = this.handleRemoveGroupByDim.bind(this);
    this.handleChangeGroupByFunc = this.handleChangeGroupByFunc.bind(this);
    this.handleAddSeries = this.handleAddSeries.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const { data } = nextProps;
    if (data !== this.props.data) {
      this.setState({ data });
    }
  }

  handleChangeTimeRange(timeRange) {
    const { data } = this.state;
    this.props.onChange({
      ...data,
      timeRange,
    });
  }

  handleAddGroupByDim(dim) {
    const { data } = this.state;
    const { groupBy = {} } = data;
    const { dims = [] } = groupBy;
    if (_.some(dims, gb => gb.type === dim)) {
      return;
    }
    this.props.onChange({
      ...data,
      groupBy: {
        ...groupBy,
        dims: _.union(dims, [{
          type: dim,
          value: kGroupOneMin,
        }]),
      },
    });
  }

  handleChangeGroupByDim(dim) {
    const { data } = this.state;
    const { groupBy = {} } = data;
    const { dims = [] } = groupBy;
    this.props.onChange({
      ...data,
      groupBy: {
        ...groupBy,
        dims: dims.map((d) => {
          if (d.type === dim.type) {
            return {
              ...d,
              ...dim,
            };
          }
          return d;
        }),
      },
    });
  }

  handleRemoveGroupByDim(type) {
    const { data } = this.state;
    const { groupBy = {} } = data;
    const { dims = [] } = groupBy;
    this.props.onChange({
      ...data,
      groupBy: {
        ...groupBy,
        dims: dims.filter(d => d.type !== type),
      },
    });
  }

  handleChangeGroupByFunc(func) {
    const { data } = this.state;
    const { groupBy = {} } = data;
    this.props.onChange({
      ...data,
      groupBy: {
        ...groupBy,
        func,
      },
    });
  }

  handleAddFilter(filter) {
    const { data } = this.state;
    const { filters = [] } = data;
    this.props.onChange({
      ...data,
      filters: _.union(filters, [{
        type: filter,
        id: Math.random() * 1000000,
      }]),
    });
  }

  handleRemoveFilter(id) {
    const { data } = this.state;
    const { filters = [] } = data;
    this.props.onChange({
      ...data,
      filters: _.filter(filters, f => f.id !== id),
    });
  }

  handleChangeFilter(filter) {
    const { data } = this.state;
    const { filters = [] } = data;
    this.props.onChange({
      ...data,
      filters: filters.map((f) => {
        if (f.id === filter.id) {
          return {
            ...f,
            ...filter,
          };
        }
        return f;
      }),
    });
  }

  handleAddSeries(serie) {
    const { data } = this.state;
    const { series = [] } = data;
    this.props.onChange({
      ...data,
      series: _.union(series, [serie]),
    });
  }

  handleRemoveSeries(serie) {
    const { data } = this.state;
    const { series = [] } = data;
    this.props.onChange({
      ...data,
      series: series.filter(s => s !== serie),
    });
  }

  render() {
    const { locale } = this.props;
    const {
      data: {
        timeRange,
        groupBy: {
          dims: groupBys = [],
          func: groupByFunc = kGroupFuncSum,
        },
        filters = [],
        series = [],
      },
      expand = true,
    } = this.state;

    return (
      <div className={`${styles.conds} ${expand ? '' : styles.collapsed}`}>
        <Collapse in={expand}>
          <div>
            <div className={styles.condGroup}>
              <span className={`${styles.label} ${styles[locale]}`}>
                <i className="fa fa-calendar-o fa-fw" aria-hidden="true" />{' '}
                {this.intlMsg.msg('timerange')}
              </span>
              <TimeRangeButton
                value={timeRange}
                onSelect={this.handleChangeTimeRange}
              />
            </div>
            <div className={styles.condGroup}>
              <span className={`${styles.label} ${styles[locale]}`}>
                <i className="fa fa-sitemap fa-fw" aria-hidden="true" />{' '}
                {this.intlMsg.msg('groupbys')}
              </span>
              <div className={styles.condBlock}>
                <div className={styles.condBlockRow}>
                  <ShowIf if={groupBys.length > 0}>
                    <span className={`${styles.label} ${styles.sub} ${styles[locale]}`}>
                      <i className="fa fa-angle-right" />{' '}
                      {this.intlMsg.msg('groupbys.dimension')}
                    </span>
                  </ShowIf>
                  {groupBys.map((gb) => {
                    if (gb.type === kGroupByTime) {
                      return (
                        <GroupByTimeButton
                          key={gb.type}
                          value={gb.value}
                          onSelect={(value) => {
                            this.handleChangeGroupByDim({ type: gb.type, value });
                          }}
                          onDelete={() => this.handleRemoveGroupByDim(gb.type)}
                        />
                      );
                    }
                    return null;
                  })}
                </div>
                <div className={styles.condBlockRow}>
                  <ShowIf if={groupBys.length > 0}>
                    <span className={`${styles.label} ${styles.sub} ${styles[locale]}`}>
                      <i className="fa fa-angle-right" />{' '}
                      {this.intlMsg.msg('groupbys.function')}
                    </span>
                  </ShowIf>
                  <ShowIf if={groupBys.length > 0}>
                    <GroupByFuncButton
                      id="group-by-func"
                      value={groupByFunc}
                      onSelect={this.handleChangeGroupByFunc}
                    />
                  </ShowIf>
                </div>
              </div>
              <NewGroupByButton onSelect={this.handleAddGroupByDim} />
            </div>

            <div className={styles.condGroup}>
              <span className={`${styles.label} ${styles[locale]}`}>
                <i className="fa fa-filter fa-fw" aria-hidden="true" />{' '}
                {this.intlMsg.msg('filters')}
              </span>
              {filters.map((filter) => {
                if (filter.type === kDeviceFilter) {
                  return (
                    <DeviceFilter
                      key={filter.id}
                      value={filter.value}
                      onDelete={() => this.handleRemoveFilter(filter.id)}
                      onChange={(e) => {
                        this.handleChangeFilter({
                          id: filter.id,
                          value: e.target.value,
                        });
                      }}
                    />
                  );
                }
                return null;
              })}
              <NewFilterButton onSelect={this.handleAddFilter} />
            </div>
            <div className={styles.condGroup}>
              <span className={`${styles.label} ${styles[locale]}`}>
                <i className="fa fa-bars fa-fw" aria-hidden="true" />{' '}
                {this.intlMsg.msg('series')}
              </span>
              {series.map((serie) => {
                if (serie === kSeriesDevice) {
                  return (
                    <DeviceSerieButton
                      key={serie}
                      onDelete={() => this.handleRemoveSeries(serie)}
                    />
                  );
                }
                return null;
              })}
              <NewSeriesButton onSelect={this.handleAddSeries} />
            </div>
          </div>
        </Collapse>
        <div className={styles.toggle}>
          <Link onClick={() => this.setState({ expand: !expand })}>
            <ShowIf if={expand}>
              <i className="fa fa-angle-double-up" />
            </ShowIf>
            <ShowIf if={!expand}>
              <i className="fa fa-angle-double-down" />
            </ShowIf>
          </Link>
        </div>
      </div>
    );
  }
}

Conditions.propTypes = propTypes;

const mapStateToProps = state => ({
  locale: state.intl.locale,
});

export default connect(mapStateToProps, null)(injectIntl(Conditions));




// WEBPACK FOOTER //
// ./src/containers/Application/coms/ApplicationDetail/coms/DataPointsView/coms/DataPointTrend/coms/Conditions/index.jsx